import React from 'react';
import {Navigate} from 'react-router-dom';
import styled from 'styled-components';
import {get} from 'lodash';
import {useStore} from '../../../store';
import {requiresPasswordChange} from '../../../utils/requiresPasswordChange';
import PasswordChangeContainer from '../containers/PasswordChangeContainer';
import {useTranslation} from 'react-i18next';

const Styled = styled.div`
  .form-btn {
    display: block;
    width: 100%;
    font-family: 'Gilroy-Bold', sans-serif;
  }

  .password-change-title {
    font-family: 'Gilroy-Bold', sans-serif;
    margin-bottom: 20px;
    font-size: 18px;
  }
`;

const PasswordChangePage = ({...rest}) => {
    const {t} = useTranslation();
    const user = useStore((state) => get(state, 'user', null));

    if (!requiresPasswordChange(user)) {
        return <Navigate to={'/products/all'} replace/>;
    }

    return (
        <Styled {...rest}>
            <p className="password-change-title">{t('Password change required')}</p>
            <PasswordChangeContainer/>
        </Styled>
    );
};

export default PasswordChangePage;
